
import React from 'react';
import { Link } from 'react-router-dom';

interface LinkItem {
  to: string;
  label: string;
  icon?: React.ReactNode;
}

interface FooterLinkGroupProps {
  title: string;
  links: LinkItem[];
}

const FooterLinkGroup: React.FC<FooterLinkGroupProps> = ({ title, links }) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      <h3 className="text-white font-medium mb-4">{title}</h3>
      <ul className="space-y-2">
        {links.map((link, index) => (
          <li key={index}>
            <Link 
              to={link.to} 
              className="text-sm text-gray-400 hover:text-white flex items-center gap-1.5"
              onClick={handleClick}
            >
              {link.icon}
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinkGroup;
